export const fr = {
  eventManagementPage: {
    meta: { title: "Gestion d'événements" },
    hero: {
      eyebrow: "Gestion d'événements",
      heading_main: "Quarts, listes d'attente et disponibilité en temps réel",
      heading_em: '',
      lead: "Purposely gère la logistique de chaque événement bénévole à votre place. Les employés sont notifiés des quarts ouverts, les quarts ouverts se remplissent d'eux-mêmes, les listes d'attente progressent dès qu'une place se libère, et la disponibilité en direct vous montre exactement où sont les lacunes avant qu'elles ne deviennent un problème.",
    },
    availStrip: "Actif sur chaque événement Purposely — mis à jour dès qu'un RSVP change.",
    shifts: {
      name: 'Quarts intelligents',
      status: 'En direct',
      headline: "Ouvrez un quart. Employés notifiés instantanément",
      desc: "Définissez quand, où et combien de bénévoles vous avez besoin — Purposely s'occupe du reste. Notre moteur de jumelage présente chaque quart aux employés les plus susceptibles de se présenter, et envoie discrètement des rappels aux indécis lorsque des places sont encore disponibles.",
      features: [
        "Inscription en un clic pour n'importe quel quart",
        "Les heures et l'impact sont publiés dans votre tableau de bord dès la fin d'un quart",
      ],
      cta: 'Voir les quarts en action →',
    },
    waitlists: {
      name: "Listes d'attente automatiques",
      status: 'En direct',
      headline: "Quelqu'un ne peut pas venir ? Le suivant est déjà inscrit",
      desc: "Chaque quart populaire dispose d'une liste d'attente. Dès qu'un RSVP est annulé, le prochain candidat est promu, notifié et ajouté à la liste — sans relance ni courriels embarrassants du style « on a trouvé une place » la veille.",
      features: [
        "Promotion automatique à l'annulation avec une fenêtre de confirmation de 30 min",
        "Repli intelligent : ignore la file si un coéquipier a déjà confirmé",
        "Historique complet de qui a été contacté et quand",
      ],
      cta: "Voir les listes d'attente en action →",
    },
    privateShifts: {
      name: 'Quarts privés et sur invitation',
      status: 'En direct',
      headline: 'Votre liste d\'invités pour votre événement',
      desc: "Toutes les opportunités n'ont pas leur place dans le calendrier de l'entreprise. Les responsables d'équipe peuvent restreindre n'importe quel quart à un groupe spécifique — utile pour les journées de bénévolat de direction, les programmes pilotes ou les partenariats que vous souhaitez garder confidentiels.",
      features: [
        "Limitez un quart à des équipes spécifiques ou à une liste d'invités sélectionnée",
        "Sur invitation uniquement : seules les personnes que vous ajoutez peuvent voir le quart ou s'y inscrire",
        "Historique complet de qui a été invité et à quel moment",
      ],
      cta: 'Voir les quarts privés →',
    },
    availability: {
      name: 'Disponibilité en temps réel',
      status: 'En direct',
      headline: "Voyez les lacunes — avant qu'elles ne deviennent des problèmes",
      desc: "Une carte de chaleur en direct indiquant quand vos employés sont les plus susceptibles de faire du bénévolat, ventilée par équipe, heure et cause. Planifiez en conséquence : publiez des quarts aux heures de pointe, orientez les rappels là où l'engagement baisse, et n'inscrivez plus jamais un événement dans un créneau mort.",
      features: [
        "Carte de chaleur de la disponibilité historique et prédite dans l'organisation",
        "Vélocité RSVP en direct — voyez le taux de remplissage d'un quart dès sa publication",
        "Rappels Slack et Teams respectueux de la présence (pas de messages à 21h)",
        "Suggestion automatique de la meilleure date et heure lors de la création d'un événement",
      ],
      cta: "Voir la carte de chaleur de votre équipe →",
    },
    faq: {
      heading: 'Logistique, capacité et contrôle',
      items: [
        {
          q: "Puis-je organiser des quarts privés ou sur invitation uniquement ?",
          a: "Oui, les responsables d'équipe peuvent restreindre n'importe quel quart à un groupe spécifique. Utile pour les journées bénévoles de direction, les programmes pilotes ou les partenariats réservés à une équipe que vous ne souhaitez pas afficher dans le calendrier de l'entreprise.",
        },
        {
          q: "Que se passe-t-il quand quelqu'un annule à la dernière minute ?",
          a: "Nous notifions la prochaine personne sur la liste, mais c'est en fin de compte à elle de décider si elle peut se libérer. En pratique, les annulations de dernière minute sont rares. Les employés reçoivent tous les détails du quart à l'avance, donc lorsqu'ils s'inscrivent, ils sont vraiment engagés.",
        },
      ],
    },
    cta: {
      heading_main: "Arrêtez de courir après les RSVP",
      heading_em: "Commencez à gérer des événements",
      sub: "Réservez une démo rapide et nous vous guiderons à travers tout ça.",
      button: "Réserver une démo →",
    },
  },
}
